import React, { useEffect, useState } from 'react'
import ViewProgressBar from './ViewProressBar/ViewProgressBar'
import AdaptiveEvalutionGraph from './AdaptiveEvalutionGraph';

function CompletedAdaptiveQs() {

    const [difficulty, setDifficulty] = useState(0);
    const [skills, setSkills] = useState(70);
    const [openGraphPopup, setOpenGraphPopup] = useState(false)
    const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
    const skillsLevels = [
        "Create",
        "Evaluate",
        "Analyze",
        "Apply",
        "Understand",
        "Remember",
    ];

    // Simulate dynamic data updates
    useEffect(() => {
        const updateProgress = () => {
            setDifficulty(Math.floor(Math.random() * 101)); // Random between 0-100
            setSkills(Math.floor(Math.random() * 101));
        };
        updateProgress()
    }, [])
    const showSummary = {
        background: "#F77F00",
        fontSize: "16px",
        padding: "11px 14px",
        fontWeight: "600",
        borderRadius: "5px",
        border: "none",
        color: '#fff'
    }
    return (
        <>
            <div className="my-2 pb-4 mx-1 ">
                <div className="d-flex align-items-center justify-content-between headingMargin ">
                    <div>
                        <img
                            onClick={() => window.history.back()}
                            style={{ cursor: "pointer" }}
                            src="/images/Back Arrow.svg"
                            alt=""
                        ></img>
                        <span
                            onClick={() => window.history.go(-1)}
                            className="published_hw_file_path1"
                        >
                            &nbsp; Assessment /&nbsp;
                        </span>
                        <span
                            onClick={() => window.history.back()}
                            className="published_hw_file_path1"
                        >
                            {/* {studentResponse?.assessment?.name} /&nbsp; */}
                            {`Testing Assessment`} /&nbsp;
                        </span>
                        <span className="published_hw_file_path2">
                            {/* {studentResponse?.student?.name} */}
                        </span>
                    </div>
                    <div>
                        <button style={showSummary} onClick={() => setOpenGraphPopup(true)}>Show Summary</button>
                    </div>
                </div>
                <div className="mt-2 ms-1 published_tittle_heading">
                    {/* {studentResponse?.assessment?.description} */}
                </div>
                <div className="mt-2 ms-1  d-flex align-items-center ">
                    <span className=" open_ststus_hw py-1 ">
                        {/* {studentResults?.length > 0 ? "Completed" : "On review"} */}
                        {"Completed"}
                    </span>
                    <span className="published_hw_header_subject_name me-2">
                        {/* &nbsp;&nbsp;{studentResponse?.assessment?.subject?.name} | */}
                        &nbsp;&nbsp;{"English"} |
                    </span>
                    <span className=" published_hw_header_subject_name me-2">
                        Scheduled:
                    </span>
                    <span className="ms-2  scheduled_date_time ">
                        {/* {dateHelper(studentResponse?.assessment?.deadline)} &nbsp; - &nbsp; */}
                        {/* {dateHelperSchedulePlusDuration(
                            studentResponse?.assessment?.schedule_date,
                            calculateDeadlineTime(
                                studentResponse?.assessment?.schedule_time,
                                studentResponse?.assessment?.total_duration
                            )
                        )} */}
                    </span>
                    <span className=" scheduled_date_time ">
                        {/* {moment(studentResponse?.assessment?.deadline).format("h:mm a")} */}
                    </span>
                </div>

                <div className="mt-3">
                    {/* <Questionnobox
                        setNextQuestion={setNextQuestion}
                        nextQuestion={nextQuestion}
                        totalResponse={responseAnswers?.length}
                    /> */}
                </div>

                <div className='row'>
                    <div className='col-6'>
                        {/* {responseAnswers?.length > 0 &&
                    (responseAnswers[nextQuestion].question?.type?.name ===
                        "MCQ Type" ||
                        !responseAnswers[nextQuestion]?.question?.type
                            ?.is_manually_graded) ? (
                    <McqQuestion
                        questionNumber={nextQuestion}
                        response={responseAnswers[nextQuestion]}
                        setResponseAnswers={setResponseAnswers}
                        studentResults={studentResults}
                    />
                ) : (
                    <UploadQuestion
                        questionNumber={nextQuestion}
                        response={responseAnswers[nextQuestion]}
                        setResponseAnswers={setResponseAnswers}
                        studentResults={studentResults}
                    />
                )} */}
                    </div>
                    <div className='col-6'>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <ViewProgressBar
                                title="Difficulty"
                                levels={difficultyLevels}
                                progress={difficulty}
                            />
                            <ViewProgressBar
                                title="Skills"
                                levels={skillsLevels}
                                progress={skills}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="onreview_btn_box">
                {/* {responseAnswers?.length !== 1 ? (
                    <button
                        onClick={() => {
                            nextQuestion > 0 && setNextQuestion(nextQuestion - 1);
                        }}
                        disabled={nextQuestion === 0}
                        className="onreviwe_preview_btn_a"
                    >
                        Previous
                    </button>
                ) : (
                    <div></div>
                )} */}
                {/* {nextQuestion !== responseAnswers?.length - 1 ? (
                    <button
                        onClick={() => {
                            nextQuestion < responseAnswers?.length &&
                                setNextQuestion(nextQuestion + 1);
                        }}
                        className="onreviwe_next_btn"
                        style={{ marginRight: "62px" }}
                    >
                        Next
                    </button>
                ) : (
                    !studentResults?.length > 0 && (
                        <button
                            onClick={handleSubmitResult}
                            style={{ width: "200px", marginRight: "62px" }}
                            className="onreviwe_next_btn"
                            disabled={inProgress}

                        >
                            Submit
                        </button>
                    )
                )} */}
                <button
                    onClick={() => {
                        // nextQuestion > 0 && setNextQuestion(nextQuestion - 1);
                    }}
                    // disabled={nextQuestion === 0}
                    className="onreviwe_preview_btn_a"
                >
                    Previous
                </button>
                <button
                    // onClick={handleSubmitResult}
                    style={{ width: "200px", marginRight: "5px" }}
                    className="onreviwe_next_btn"
                // disabled={inProgress}

                >
                    Submit
                </button>

                {
                    openGraphPopup && (
                        <AdaptiveEvalutionGraph setOpenGraphPopup={setOpenGraphPopup} />
                    )
                }
            </div>
        </>
    )
}

export default CompletedAdaptiveQs